export class LottieLoader {
    observer: IntersectionObserver;
    private static isLottieConfigured = false;

    constructor() {
        this.observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.loadLottie(entry.target as HTMLElement);
                    observer.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '200px' // Load when close to viewport
        });

        this.init();
    }

    init() {
        const elements = document.querySelectorAll(".lottie-anim");
        elements.forEach((element) => {
            this.observer.observe(element);
        });
    }

    async loadLottie(element: HTMLElement) {
        const src = element.getAttribute("data-src");
        const loop = element.getAttribute("data-loop") !== "false";

        if (src && !element.classList.contains('lottie-loaded')) {
            try {
                // Dynamic import - using light version to save ~30kb
                // @ts-ignore
                const lottieModule = await import("lottie-web/build/player/lottie_light");
                const lottie = lottieModule.default;

                if (!LottieLoader.isLottieConfigured) {
                    // Set lower quality to improve performance on high-DPI screens
                    lottie.setQuality("low");
                    LottieLoader.isLottieConfigured = true;
                }

                lottie.loadAnimation({
                    container: element,
                    renderer: "svg", 
                    loop: loop,
                    autoplay: true,
                    path: src,
                    rendererSettings: {
                        preserveAspectRatio: 'xMidYMid slice',
                    }
                });
                element.classList.add('lottie-loaded');
            } catch (error) {
                console.error("Failed to load lottie-web", error);
            }
        }
    }
}

new LottieLoader();
